import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';
import { DrawDashboard } from '../../../draws/DrawDashboard';
import { DrawSummary } from '../../../draws/DrawSummary';

export default function DrawRoutes() {
    return (
        <>
            <Route
                path='/draw/dashboard'
                element={
                    <RequireAdmin>
                        <DrawDashboard />
                    </RequireAdmin>
                }
            />
            <Route
                path='/draw/:drawBudgetId'
                element={
                    <RequireAdmin>
                        <DrawSummary isAdmin={true} />
                    </RequireAdmin>
                }
            />
        </>
    );
}
